import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../nest-api';
import { NestAuthProvider } from '../nest-auth';

@Injectable()
export class AnnouncementProvider {

  private _service: string = 'attendance';
  private _model: string = 'announcement';

  constructor(
    private nestApiProvider: NestApiProvider,
    private httpClient: HttpClient,
    private nestAuthProvider: NestAuthProvider
  ) {
  }

  public getAnnouncement(page: number, limit:number): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getAnnouncement';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof page !== 'undefined' && page !== null) _urlParams.page = page;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, null, null, null, false);
  }

  public getAnnouncementSf6(params: any): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'cfcDirect';
    const _params: any = params;
    const route = 'ofid=CompanyGD.listingAnnouncement';
    const _urlParams: any = {};
    const _body: any = {};
    const _url = this.nestApiProvider.urlBuilder(_method, 'builder', _func, {}, _urlParams, 'default');
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, null, null, null, false, route );
  }

  public editAnnouncement(code: string, subject: string, description: string, attachment: string ): Observable<any> {
    const _method: string = "POST";
    const _func: string = "editAnnouncement";
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof code !== 'undefined' && code !== null) _urlParams.code = code;
    if (typeof subject !== 'undefined' && subject !== null) _urlParams.subject = subject;
    if (typeof description !== 'undefined' && description !== null) _urlParams.description = description;
    if (typeof attachment !== 'undefined' && attachment !== null) _urlParams.attachment = attachment

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public addAnnouncement(subject: string, description: string, attachment: string): Observable<any> {
    const _method: string = "POST";
    const _func: string = "addAnnouncement";
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof subject !== 'undefined' && subject !== null) _urlParams.subject = subject;
    if (typeof description !== 'undefined' && description !== null) _urlParams.description = description;
    if (typeof attachment !== 'undefined' && attachment !== null) _urlParams.attachment = attachment

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public deleteAnnouncement(code: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'deleteAnnouncement';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof code !== 'undefined' && code !== null) _urlParams.code = code;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public storagePolicyAnnouncement(fileName: string): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'storagePolicyAnnouncement';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof fileName !== 'undefined' && fileName !== null) _urlParams.fileName = fileName;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }



}



// WEBPACK FOOTER //
// ./src/shared/nestjs/announcement/announcement.ts